import * as React from 'react';
import { SVGProps } from 'react';

const IconIntroductionSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 1h-2v14h2V1zM5.06 4.465l2.534 2.541L1 6.994v2l6.594.012-2.534 2.53 1.414 1.414 4.949-4.944-4.95-4.955L5.06 4.465z" />
  </svg>
);
export default IconIntroductionSizeS;
